import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe, formatDate } from "@angular/common";

@Pipe({
    name: "dueDate",
    pure: true
})

export class dueDatePipe extends DatePipe implements PipeTransform {
    offsetTimeZone: any;
    offsetMinutes: any;
    offsetTimeVal: any;
    transform(value: any, pattern: string = "dd/MM/yyyy hh:mmaaaaa\'m\'", patternzero: string = "dd/MM/yyyy hh:mmaaaaa\'m\'"): string | null {
        if (value) {
            if (value != null && value != '' && value != 'none' && value != 'None') {


                this.offsetTimeZone = (typeof localStorage.getItem('timezone') === 'undefined') ? null : localStorage.getItem('timezone');

                if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

                    this.offsetTimeZone = -5.00;
                    this.offsetMinutes = 0;

                    this.offsetTimeVal = (-5.00 * 3600000);

                }
                else {

                    this.offsetTimeZone = localStorage.getItem('timezone');
                    this.offsetMinutes = 30;
                    this.offsetTimeVal = (this.offsetTimeZone * 3600000);




                }


                let date: any = new Date(value);

                let dateCheck: any = new Date(value);
                var dateDue = formatDate(dateCheck, 'yyyy-MM-dd HH:mm:ss', 'en-US')



                if (dateDue <= formatDate(dateDue, 'yyyy-MM-dd HH:mm:ss', 'en-US')) {

                    var dateTimeZoneDiff = new Date(date);
                    dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
                    let result = super.transform(dateTimeZoneDiff, patternzero);
                    return result;

                }

                else {
                    var dateTimeZoneDiff1 = new Date(date);
                    dateTimeZoneDiff1.setMilliseconds(Number(this.offsetTimeVal));
                    let result = super.transform(dateTimeZoneDiff1, pattern);
                    return result;
                }


            }
            else {
                return '';
            }

        }
    }
}






